/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Vault, VaultInterface } from "../Vault";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "BadDebtSettled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "clearingHouse",
        type: "address",
      },
    ],
    name: "ClearingHouseChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "collateralToken",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "liquidator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "collateral",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "repaidSettlementWithoutInsuranceFundFeeX10_S",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "insuranceFundFeeX10_S",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint24",
        name: "discountRatio",
        type: "uint24",
      },
    ],
    name: "CollateralLiquidated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "collateralManager",
        type: "address",
      },
    ],
    name: "CollateralManagerChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "collateralToken",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Deposited",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "trustedForwarder",
        type: "address",
      },
    ],
    name: "TrustedForwarderChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "trustedForwarder",
        type: "address",
      },
    ],
    name: "TrustedForwarderUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "WETH9",
        type: "address",
      },
    ],
    name: "WETH9Changed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "collateralToken",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Withdrawn",
    type: "event",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "depositEther",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "depositEtherFor",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "depositFor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getAccountBalance",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
    ],
    name: "getAccountValue",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
    ],
    name: "getBalance",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "getBalanceByToken",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getClearingHouse",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getClearingHouseConfig",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCollateralManager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCollateralMmRatio",
    outputs: [
      {
        internalType: "uint24",
        name: "",
        type: "uint24",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
    ],
    name: "getCollateralTokens",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getExchange",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
    ],
    name: "getFreeCollateral",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "uint24",
        name: "ratio",
        type: "uint24",
      },
    ],
    name: "getFreeCollateralByRatio",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "getFreeCollateralByToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getInsuranceFund",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "settlementX10_S",
        type: "uint256",
      },
    ],
    name: "getLiquidatableCollateralBySettlement",
    outputs: [
      {
        internalType: "uint256",
        name: "collateral",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
    ],
    name: "getMarginRequirementForCollateralLiquidation",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "getMaxRepaidSettlementAndLiquidatableCollateral",
    outputs: [
      {
        internalType: "uint256",
        name: "maxRepaidSettlementX10_S",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxLiquidatableCollateral",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "collateral",
        type: "uint256",
      },
    ],
    name: "getRepaidSettlementByCollateral",
    outputs: [
      {
        internalType: "uint256",
        name: "settlementX10_S",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getSettlementToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
    ],
    name: "getSettlementTokenValue",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTotalDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTrustedForwarder",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getWETH9",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "insuranceFundArg",
        type: "address",
      },
      {
        internalType: "address",
        name: "clearingHouseConfigArg",
        type: "address",
      },
      {
        internalType: "address",
        name: "accountBalanceArg",
        type: "address",
      },
      {
        internalType: "address",
        name: "exchangeArg",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
    ],
    name: "isLiquidatable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "isDenominatedInSettlementToken",
        type: "bool",
      },
    ],
    name: "liquidateCollateral",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "clearingHouseArg",
        type: "address",
      },
    ],
    name: "setClearingHouse",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "collateralManagerArg",
        type: "address",
      },
    ],
    name: "setCollateralManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trustedForwarderArg",
        type: "address",
      },
    ],
    name: "setTrustedForwarder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "WETH9Arg",
        type: "address",
      },
    ],
    name: "setWETH9",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
    ],
    name: "settleBadDebt",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "versionRecipient",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "withdrawAll",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawAllEther",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdrawEther",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b5061592c80620000216000396000f3fe6080604052600436106102ad5760003560e01c80638456cb5911610165578063c575ff79116100cc578063dfa441be11610085578063dfa441be146107cc578063ed903f7a146107e1578063f3fef3a31461080e578063f807cd221461082e578063f8b2cb4f14610843578063f8c8765e14610863578063fa09e63014610883576102f8565b8063c575ff791461072d578063c804cf6014610742578063ca91e18c14610762578063ce1b815f14610782578063d9fd870b14610797578063da742228146107ac576102f8565b8063b3db428b1161011e578063b3db428b14610678578063b800a6b314610698578063bc5920ba146106b8578063c0e695b8146106cd578063c3999444146106ed578063c3b66b311461070d576102f8565b80638456cb59146105e15780638da5cb5b146105f657806398ea5fca1461060b578063a9b786b214610613578063aa2a829414610641578063ac4531bd14610656576102f8565b80633ffd1303116102145780635ae80951116101cd5780635ae809511461052d5780635c975abb1461054d5780636896fabf146105625780636c8381f814610577578063715018a61461058c57806371b6a5bb146105a1578063842a05d4146105c1576102f8565b80633ffd130314610478578063449323d81461049857806347e7ef24146104b8578063486ff0cd146104d85780634faa8a26146104fa578063572b6c051461050d576102f8565b80632e40a51b116102665780632e40a51b146103d7578063313ce567146103f757806331c911171461041957806334ce998a1461042e5780633bed33ce146104435780633f4ba83a14610463576102f8565b8063042e02cf146102fd57806308511abb1461033357806312803c7d1461036057806312ca1d171461038257806313af4035146103a2578063158626f7146103c2576102f8565b366102f857610139546001600160a01b03166102c76108a3565b6001600160a01b0316146102f65760405162461bcd60e51b81526004016102ed90615664565b60405180910390fd5b005b600080fd5b34801561030957600080fd5b5061031d610318366004614f2f565b6108b3565b60405161032a9190615333565b60405180910390f35b34801561033f57600080fd5b5061035361034e36600461503a565b610a96565b60405161032a919061533e565b34801561036c57600080fd5b50610375610c14565b60405161032a91906152b3565b34801561038e57600080fd5b5061035361039d366004614f67565b610c29565b3480156103ae57600080fd5b506102f66103bd366004614f2f565b610d95565b3480156103ce57600080fd5b50610375610ef0565b3480156103e357600080fd5b506103536103f2366004614f67565b610f00565b34801561040357600080fd5b5061040c610f2c565b60405161032a9190615722565b34801561042557600080fd5b50610353610f36565b34801561043a57600080fd5b50610353611011565b34801561044f57600080fd5b506102f661045e36600461527a565b611018565b34801561046f57600080fd5b506102f66110d6565b34801561048457600080fd5b50610353610493366004615081565b61113d565b3480156104a457600080fd5b506102f66104b3366004614f2f565b611162565b3480156104c457600080fd5b506102f66104d33660046150ae565b611238565b3480156104e457600080fd5b506104ed611336565b60405161032a9190615347565b6102f6610508366004614f2f565b611355565b34801561051957600080fd5b5061031d610528366004614f2f565b611423565b34801561053957600080fd5b50610353610548366004614f2f565b611437565b34801561055957600080fd5b5061031d611459565b34801561056e57600080fd5b50610375611462565b34801561058357600080fd5b50610375611472565b34801561059857600080fd5b506102f6611481565b3480156105ad57600080fd5b506103536105bc366004614f2f565b611522565b3480156105cd57600080fd5b506102f66105dc366004614f2f565b6115b8565b3480156105ed57600080fd5b506102f661168e565b34801561060257600080fd5b506103756116f3565b6102f6611702565b34801561061f57600080fd5b5061063361062e366004614f67565b6117af565b60405161032a9291906156f4565b34801561064d57600080fd5b506103756118f5565b34801561066257600080fd5b5061066b611905565b60405161032a91906156e4565b34801561068457600080fd5b506102f6610693366004614ffa565b611a02565b3480156106a457600080fd5b506103536106b33660046150ae565b611b27565b3480156106c457600080fd5b506102f6611c03565b3480156106d957600080fd5b506103536106e83660046150ae565b611cef565b3480156106f957600080fd5b50610353610708366004614f2f565b611db9565b34801561071957600080fd5b50610353610728366004614f2f565b611dd0565b34801561073957600080fd5b50610375611de7565b34801561074e57600080fd5b506102f661075d366004614f2f565b611df7565b34801561076e57600080fd5b506102f661077d366004614f2f565b611fa5565b34801561078e57600080fd5b5061037561207b565b3480156107a357600080fd5b5061037561208a565b3480156107b857600080fd5b506102f66107c7366004614f2f565b61209a565b3480156107d857600080fd5b50610375612165565b3480156107ed57600080fd5b506108016107fc366004614f2f565b612175565b60405161032a91906152e6565b34801561081a57600080fd5b506102f66108293660046150ae565b6121ec565b34801561083a57600080fd5b506103756122df565b34801561084f57600080fd5b5061035361085e366004614f2f565b6122ef565b34801561086f57600080fd5b506102f661087e366004614f9f565b612322565b34801561088f57600080fd5b5061035361089e366004614f2f565b6125e3565b60006108ad6126ef565b90505b90565b6001600160a01b038116600090815261013a6020526040812080546108dc576000915050610a91565b60006108e78461271f565b5090506108f384611522565b81121561090557600192505050610a91565b600061091085612744565b90506000808212610922576000610933565b61093361092e83612769565b612795565b90506109ce61013860009054906101000a90046001600160a01b03166001600160a01b031663b6113be66040518163ffffffff1660e01b815260040160206040518083038186803b15801561098757600080fd5b505afa15801561099b573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906109bf919061525e565b6109c8886127f0565b9061294c565b8111156109e2576001945050505050610a91565b61013854604051632bc54f5b60e01b81526001600160a01b0390911690632bc54f5b90610a139089906004016152b3565b60206040518083038186803b158015610a2b57600080fd5b505afa158015610a3f573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610a6391906151a2565b61013054610a7590839060ff16612961565b1115610a88576001945050505050610a91565b60009450505050505b919050565b6000610aa0611459565b15610ae5576040805162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b604482015290519081900360640190fd5b60026001541415610b2b576040805162461bcd60e51b815260206004820152601f6024820152600080516020615789833981519152604482015290519081900360640190fd5b6002600155610b39856108b3565b610b555760405162461bcd60e51b81526004016102ed906155c6565b600080610b6287876117af565b9150915060008060008615610bb65787915084821115610b945760405162461bcd60e51b81526004016102ed90615586565b848214610baa57610ba58983611b27565b610bac565b835b9250829050610bf7565b87925083831115610bd95760405162461bcd60e51b81526004016102ed90615470565b838314610bef57610bea8984611cef565b610bf1565b845b91508190505b610c038a8a8486612977565b600180559998505050505050505050565b6101305461010090046001600160a01b031690565b600080610c3584612744565b1215610c4357506000610d8f565b6000610c4e84612b7d565b905080610c5f576000915050610d8f565b610130546001600160a01b03848116610100909204161415610cc6576000610c8685612c1c565b5090506000811315610cba5761013054610cb59060ff16610caf84610caa85612795565b612d75565b90612961565b610cbd565b60005b92505050610d8f565b600080610cd285612d8b565b61013854604051631ed4896760e31b81529294509092506000916001600160a01b039091169063f6a44b3890610d0c9089906004016152b3565b60806040518083038186803b158015610d2457600080fd5b505afa158015610d38573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610d5c91906151e7565b602001519050610d88610d7b82610d7589888888612e9f565b90612ef9565b610caa61092e8a8a610f00565b9450505050505b92915050565b610d9d6108a3565b6001600160a01b0316610dae6116f3565b6001600160a01b031614610df2576040805162461bcd60e51b8152602060048201526006602482015265534f5f434e4f60d01b604482015290519081900360640190fd5b6001600160a01b038116610e36576040805162461bcd60e51b81526020600482015260066024820152650534f5f4e57360d41b604482015290519081900360640190fd5b6065546001600160a01b0382811691161415610e82576040805162461bcd60e51b8152602060048201526006602482015265534f5f53414f60d01b604482015290519081900360640190fd5b6066546001600160a01b0382811691161415610ece576040805162461bcd60e51b8152602060048201526006602482015265534f5f53414360d01b604482015290519081900360640190fd5b606680546001600160a01b0319166001600160a01b0392909216919091179055565b610133546001600160a01b031690565b6001600160a01b0391821660009081526101376020908152604080832093909416825291909152205490565b6101305460ff1690565b6000610f40611459565b15610f85576040805162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b604482015290519081900360640190fd5b60026001541415610fcb576040805162461bcd60e51b815260206004820152601f6024820152600080516020615789833981519152604482015290519081900360640190fd5b6002600155610fd8612f0e565b6000610fe26108a3565b61013954909150610ffd9082906001600160a01b0316610c29565b91506110098183612f40565b506001805590565b6101365490565b611020611459565b15611065576040805162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b604482015290519081900360640190fd5b600260015414156110ab576040805162461bcd60e51b815260206004820152601f6024820152600080516020615789833981519152604482015290519081900360640190fd5b60026001556110b8612f0e565b60006110c26108a3565b90506110ce8183612f40565b505060018055565b6110de6108a3565b6001600160a01b03166110ef6116f3565b6001600160a01b031614611133576040805162461bcd60e51b8152602060048201526006602482015265534f5f434e4f60d01b604482015290519081900360640190fd5b61113b613010565b565b6101305460009061115b9060ff1661115585856130b0565b906130e6565b9392505050565b61116a6108a3565b6001600160a01b031661117b6116f3565b6001600160a01b0316146111bf576040805162461bcd60e51b8152602060048201526006602482015265534f5f434e4f60d01b604482015290519081900360640190fd5b6111d1816001600160a01b031661312f565b6111ed5760405162461bcd60e51b81526004016102ed906154b0565b61013580546001600160a01b0319166001600160a01b0383169081179091556040517fd0654f5900f9e7e4e605a19334306e6a2786bbf960ac0484a4c12feb6428fe2f90600090a250565b611240611459565b15611285576040805162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b604482015290519081900360640190fd5b600260015414156112cb576040805162461bcd60e51b815260206004820152601f6024820152600080516020615789833981519152604482015290519081900360640190fd5b60026001556101305482906001600160a01b038083166101009092041614806112f857506112f881613135565b6113145760405162461bcd60e51b81526004016102ed90615490565b600061131e6108a3565b905061132c818286866131b7565b5050600180555050565b6040805180820190915260058152640322e302e360dc1b602082015290565b61135d611459565b156113a2576040805162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b604482015290519081900360640190fd5b600260015414156113e8576040805162461bcd60e51b815260206004820152601f6024820152600080516020615789833981519152604482015290519081900360640190fd5b60026001556001600160a01b0381166114135760405162461bcd60e51b81526004016102ed906154d0565b61141c816131f3565b5060018055565b60fd546001600160a01b0390811691161490565b6000806114438361271f565b506101305490915061115b90829060ff166130e6565b60995460ff1690565b610132546001600160a01b031690565b6066546001600160a01b031690565b6114896108a3565b6001600160a01b031661149a6116f3565b6001600160a01b0316146114de576040805162461bcd60e51b8152602060048201526006602482015265534f5f434e4f60d01b604482015290519081900360640190fd5b6065546040516000916001600160a01b03169060008051602061583a833981519152908390a3606580546001600160a01b0319908116909155606680549091169055565b6000610d8f6115b3611532611905565b61013254604051633666e41760e11b81526001600160a01b0390911690636ccdc82e906115639088906004016152b3565b60206040518083038186803b15801561157b57600080fd5b505afa15801561158f573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906109c891906151a2565b61328d565b6115c06108a3565b6001600160a01b03166115d16116f3565b6001600160a01b031614611615576040805162461bcd60e51b8152602060048201526006602482015265534f5f434e4f60d01b604482015290519081900360640190fd5b611627816001600160a01b031661312f565b6116435760405162461bcd60e51b81526004016102ed90615644565b61013880546001600160a01b0319166001600160a01b0383169081179091556040517f7f1f6e997b7238fb3f4ee953b0630eda9d99527ae013f1e84bd916457e0a9dd490600090a250565b6116966108a3565b6001600160a01b03166116a76116f3565b6001600160a01b0316146116eb576040805162461bcd60e51b8152602060048201526006602482015265534f5f434e4f60d01b604482015290519081900360640190fd5b61113b6132d5565b6065546001600160a01b031690565b61170a611459565b1561174f576040805162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b604482015290519081900360640190fd5b60026001541415611795576040805162461bcd60e51b815260206004820152601f6024820152600080516020615789833981519152604482015290519081900360640190fd5b600260015560006117a46108a3565b905061141c816131f3565b6000806117bb83613135565b6117d75760405162461bcd60e51b81526004016102ed90615603565b60006117e285613358565b61013854604051631ed4896760e31b81529192506000916001600160a01b039091169063f6a44b38906118199088906004016152b3565b60806040518083038186803b15801561183157600080fd5b505afa158015611845573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061186991906151e7565b60400151905060008061187b87612d8b565b90925090506000611899611892620f4240866135f2565b849061294c565b90506118a788868385612e9f565b955060006118b861092e8b8b610f00565b9050808711156118d4578096506118d189888486613624565b95505b610130546118e690879060ff16612961565b97505050505050509250929050565b610131546001600160a01b031690565b6101385460408051633bc1d7ab60e01b8152905160009283926001600160a01b039091169163648cff3a918391633bc1d7ab91600480820192602092909190829003018186803b15801561195857600080fd5b505afa15801561196c573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611990919061525e565b6040518263ffffffff1660e01b81526004016119ac91906156e4565b60206040518083038186803b1580156119c457600080fd5b505afa1580156119d8573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906119fc919061525e565b91505090565b611a0a611459565b15611a4f576040805162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b604482015290519081900360640190fd5b60026001541415611a95576040805162461bcd60e51b815260206004820152601f6024820152600080516020615789833981519152604482015290519081900360640190fd5b60026001556101305482906001600160a01b03808316610100909204161480611ac25750611ac281613135565b611ade5760405162461bcd60e51b81526004016102ed90615490565b6001600160a01b038416611b045760405162461bcd60e51b81526004016102ed906154d0565b6000611b0e6108a3565b9050611b1c818686866131b7565b505060018055505050565b61013854604051631ed4896760e31b815260009182916001600160a01b039091169063f6a44b3890611b5d9087906004016152b3565b60806040518083038186803b158015611b7557600080fd5b505afa158015611b89573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611bad91906151e7565b604001519050600080611bbf86612d8b565b610130549193509150611bf9908790611bdc90889060ff16613672565b611bf3611bec620f4240886135f2565b869061294c565b84612e9f565b9695505050505050565b6066546001600160a01b0316611c48576040805162461bcd60e51b81526020600482015260056024820152640534f5f43360dc1b604482015290519081900360640190fd5b611c506108a3565b6066546001600160a01b03908116911614611c9b576040805162461bcd60e51b8152602060048201526006602482015265534f5f434e4360d01b604482015290519081900360640190fd5b6066546065546040516001600160a01b03928316929091169060008051602061583a83398151915290600090a360668054606580546001600160a01b03199081166001600160a01b03841617909155169055565b61013854604051631ed4896760e31b815260009182916001600160a01b039091169063f6a44b3890611d259087906004016152b3565b60806040518083038186803b158015611d3d57600080fd5b505afa158015611d51573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611d7591906151e7565b604001519050600080611d8786612d8b565b610130549193509150611bf99060ff16610caf8888611db3611dac620f42408a6135f2565b889061294c565b86613624565b61013054600090610d8f9060ff16610caf84612b7d565b61013054600090610d8f9060ff1661115584612744565b610135546001600160a01b031690565b610133546001600160a01b0382811691161415611e265760405162461bcd60e51b81526004016102ed906153da565b610132546040516357ba739b60e11b81526001600160a01b039091169063af74e73690611e579084906004016152b3565b60006040518083038186803b158015611e6f57600080fd5b505afa158015611e83573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052611eab91908101906150d9565b51151580611ed157506001600160a01b038116600090815261013a602052604090205415155b15611edb57611fa2565b6000611ee682612c1c565b5061013054909150600090611eff90839060ff166130e6565b905060008112611f10575050611fa2565b6000611f1b82612769565b61013054610133549192506001600160a01b03610100909104811691611f4391168285613688565b611f4e858284613688565b6000611f5983612795565b9050856001600160a01b03167f73bac9d49ae6f49cdba3f7381211c12a239898097e5dfdfefcbb904f8b66923882604051611f94919061533e565b60405180910390a250505050505b50565b611fad6108a3565b6001600160a01b0316611fbe6116f3565b6001600160a01b031614612002576040805162461bcd60e51b8152602060048201526006602482015265534f5f434e4f60d01b604482015290519081900360640190fd5b612014816001600160a01b031661312f565b6120305760405162461bcd60e51b81526004016102ed906155e4565b61013980546001600160a01b0319166001600160a01b0383169081179091556040517f058d4d3b4c34c38d2a57d5abcbfceff6b01f10883bb6a6033f394a98ffbc6ed190600090a250565b60fd546001600160a01b031690565b610139546001600160a01b031690565b6120a26108a3565b6001600160a01b03166120b36116f3565b6001600160a01b0316146120f7576040805162461bcd60e51b8152602060048201526006602482015265534f5f434e4f60d01b604482015290519081900360640190fd5b612109816001600160a01b031661312f565b6121255760405162461bcd60e51b81526004016102ed906155a6565b61212e8161391b565b6040516001600160a01b038216907f871264f4293af7d2865ae7eae628b228f4991c57cb45b39c99f0b774ebe2901890600090a250565b610138546001600160a01b031690565b6001600160a01b038116600090815261013a60209081526040918290208054835181840281018401909452808452606093928301828280156121e057602002820191906000526020600020905b81546001600160a01b031681526001909101906020018083116121c2575b50505050509050919050565b6121f4611459565b15612239576040805162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b604482015290519081900360640190fd5b6002600154141561227f576040805162461bcd60e51b815260206004820152601f6024820152600080516020615789833981519152604482015290519081900360640190fd5b60026001556101305482906001600160a01b038083166101009092041614806122ac57506122ac81613135565b6122c85760405162461bcd60e51b81526004016102ed90615490565b60006122d26108a3565b905061132c81858561396f565b610134546001600160a01b031690565b6001600160a01b039081166000908152610137602090815260408083206101305461010090049094168352929052205490565b600054610100900460ff168061233b575061233b6139c8565b80612349575060005460ff16155b6123845760405162461bcd60e51b815260040180806020018281038252602e8152602001806157ca602e913960400191505060405180910390fd5b600054610100900460ff161580156123af576000805460ff1961ff0019909116610100171660011790555b6000856001600160a01b03166321df0da76040518163ffffffff1660e01b815260040160206040518083038186803b1580156123ea57600080fd5b505afa1580156123fe573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906124229190614f4b565b90506000816001600160a01b031663313ce5676040518163ffffffff1660e01b815260040160206040518083038186803b15801561245f57600080fd5b505afa158015612473573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906124979190615292565b905060128160ff1611156124bd5760405162461bcd60e51b81526004016102ed906156c4565b6124cf866001600160a01b031661312f565b6124eb5760405162461bcd60e51b81526004016102ed9061539a565b6124fd856001600160a01b031661312f565b6125195760405162461bcd60e51b81526004016102ed906156a4565b61252b846001600160a01b031661312f565b6125475760405162461bcd60e51b81526004016102ed90615530565b61254f6139d9565b612557613a82565b610130805460ff191660ff9290921691909117610100600160a81b0319166101006001600160a01b039384160217905561013380546001600160a01b0319908116888416179091556101318054821687841617905561013280548216868416179055610134805490911691841691909117905580156125dc576000805461ff00191690555b5050505050565b60006125ed611459565b15612632576040805162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b604482015290519081900360640190fd5b60026001541415612678576040805162461bcd60e51b815260206004820152601f6024820152600080516020615789833981519152604482015290519081900360640190fd5b60026001556101305482906001600160a01b038083166101009092041614806126a557506126a581613135565b6126c15760405162461bcd60e51b81526004016102ed90615490565b60006126cb6108a3565b90506126d78185610c29565b92506126e481858561396f565b505060018055919050565b600060143610801590612706575061270633611423565b1561271a575060131936013560601c6108b0565b503390565b600080600061272d84613b1f565b909250905061273c8282613b54565b925050915091565b600080600061275284612c1c565b90925090506127618282613b54565b949350505050565b6000600160ff1b821361278e5760405162461bcd60e51b81526004016102ed9061554f565b5060000390565b6000808212156127ec576040805162461bcd60e51b815260206004820181905260248201527f53616665436173743a2076616c7565206d75737420626520706f736974697665604482015290519081900360640190fd5b5090565b6001600160a01b038116600090815261013a602090815260408083208054825181850281018501909352808352849383018282801561285857602002820191906000526020600020905b81546001600160a01b0316815260019091019060200180831161283a575b505083519394506000925050505b8181101561294457600083828151811061287c57fe5b6020026020010151905060006128928783613bb9565b61013854604051631ed4896760e31b81529192506000916001600160a01b039091169063f6a44b38906128c99086906004016152b3565b60806040518083038186803b1580156128e157600080fd5b505afa1580156128f5573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061291991906151e7565b60200151905061293361292c838361294c565b8890613bec565b965050600190920191506128669050565b505050919050565b600061115b838362ffffff16620f4240613c46565b600061115b8360ff601285900316600a0a613cf5565b60006129816108a3565b6101305490915061010090046001600160a01b03166129a1818386613d5c565b6129b486866129af86613e8d565b613688565b610138546040805163ddb1381360e01b815290516000926001600160a01b03169163ddb13813916004808301926020929190829003018186803b1580156129fa57600080fd5b505afa158015612a0e573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612a32919061525e565b90506000612a40868361294c565b61013354909150612a5e906001600160a01b0316846129af8461328d565b6000612a6a8783613ea1565b9050612a7a89856129af8461328d565b612a85888688613ef8565b61013854604051631ed4896760e31b81526000916001600160a01b03169063f6a44b3890612ab7908c906004016152b3565b60806040518083038186803b158015612acf57600080fd5b505afa158015612ae3573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612b0791906151e7565b604001519050856001600160a01b0316896001600160a01b03168b6001600160a01b03167fbd3320c61b99a54ed3537dce8a75020f70b61d6dd124b6aa28738d1bab9bf77d8a868887604051612b609493929190615702565b60405180910390a4612b718a611df7565b50505050505050505050565b6000610d8f61092e612c158461013160009054906101000a90046001600160a01b03166001600160a01b031663543ce73a6040518163ffffffff1660e01b815260040160206040518083038186803b158015612bd857600080fd5b505afa158015612bec573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612c10919061525e565b6130b0565b6000613f4a565b610134546040516380f57f1160e01b8152600091829182916001600160a01b0316906380f57f1190612c529087906004016152b3565b60206040518083038186803b158015612c6a57600080fd5b505afa158015612c7e573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612ca291906151a2565b6101325460405163bba85bcf60e01b815291925060009182916001600160a01b03169063bba85bcf90612cd99089906004016152b3565b60606040518083038186803b158015612cf157600080fd5b505afa158015612d05573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612d2991906151ba565b9095509092509050612d6b612d5183612d4b86612d458661328d565b90613f5a565b90613b54565b61013054612d4b9060ff16612d658a6122ef565b90613fbf565b9450505050915091565b6000818310612d84578161115b565b5090919050565b6101385460405163449e815d60e01b815260009182916001600160a01b039091169063449e815d90612dc5908690610384906004016152c7565b60206040518083038186803b158015612ddd57600080fd5b505afa158015612df1573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612e1591906151a2565b61013854604051638c8557d960e01b81526001600160a01b0390911690638c8557d990612e469087906004016152b3565b60206040518083038186803b158015612e5e57600080fd5b505afa158015612e72573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612e969190615292565b91509150915091565b600080612eab86613fd5565b905060128160ff1611612edb57612ed6601282612ecf8860ff8816600a0a89614048565b9190614082565b611bf9565b611bf960ff8416600a0a85612ef288601286614082565b9190614048565b600061115b83620f42408462ffffff16613c46565b61013954612f24906001600160a01b0316613135565b61113b5760405162461bcd60e51b81526004016102ed90615683565b610139546001600160a01b0316612f588382846140cf565b604051632e1a7d4d60e01b81526001600160a01b03821690632e1a7d4d90612f8490859060040161533e565b600060405180830381600087803b158015612f9e57600080fd5b505af1158015612fb2573d6000803e3d6000fd5b50505050612fc08383614245565b826001600160a01b0316816001600160a01b03167fd1c19fbcd4551a5edfb66d43d2e337c04837afda3482b42bdf569a8fccdae5fb84604051613003919061533e565b60405180910390a3505050565b613018611459565b613060576040805162461bcd60e51b815260206004820152601460248201527314185d5cd8589b194e881b9bdd081c185d5cd95960621b604482015290519081900360640190fd5b6099805460ff191690557f5db9ee0a495bf2e6ff9c91a7834c1ba4fdd244a5e8aa4e537bd38aeae4b073aa6130936108a3565b604080516001600160a01b039092168252519081900360200190a1565b60008060006130be8561271f565b9150915060006130ce8686614334565b9050611bf96130dc8261328d565b612d4584866143c6565b600060ff601283900316600a0a81808512801561310e575081856000038161310a57fe5b0615155b1561311857506000195b61312681612d4b87856143d5565b95945050505050565b3b151590565b610138546040516303b8879560e21b81526000916001600160a01b031690630ee21e54906131679085906004016152b3565b60206040518083038186803b15801561317f57600080fd5b505afa158015613193573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610d8f9190615186565b600081116131d75760405162461bcd60e51b81526004016102ed90615512565b6131e2828583613d5c565b6131ed82848361448d565b50505050565b34806132115760405162461bcd60e51b81526004016102ed90615512565b613219612f0e565b6101395460408051630d0e30db60e41b815290516001600160a01b0390921691829163d0e30db091859160048082019260009290919082900301818588803b15801561326457600080fd5b505af1158015613278573d6000803e3d6000fd5b505050505061328881848461448d565b505050565b60006001600160ff1b038211156127ec5760405162461bcd60e51b81526004018080602001828103825260288152602001806158816028913960400191505060405180910390fd5b6132dd611459565b15613322576040805162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b604482015290519081900360640190fd5b6099805460ff191660011790557f62e78cea01bee320cd4e420270b5ea74000d11b0c9f74754ebdbfc544b05a2586130936108a3565b60008061336483612744565b90506000808212613376576000613382565b61338261092e83612769565b905060006134168561013160009054906101000a90046001600160a01b03166001600160a01b031663543ce73a6040518163ffffffff1660e01b815260040160206040518083038186803b1580156133d957600080fd5b505afa1580156133ed573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190613411919061525e565b614334565b905060006134248383614740565b6101305461013854604080516348896fcd60e01b815290519394506000936134b79360ff16926001600160a01b0316916348896fcd916004808301926020929190829003018186803b15801561347957600080fd5b505afa15801561348d573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906134b191906151a2565b90613672565b905060008183116134c85782613546565b610138546040805162db540160e11b81529051613546926001600160a01b0316916301b6a802916004808301926020929190829003018186803b15801561350e57600080fd5b505afa158015613522573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611892919061525e565b90506135e66135df61013860009054906101000a90046001600160a01b03166001600160a01b031663ddb138136040518163ffffffff1660e01b815260040160206040518083038186803b15801561359d57600080fd5b505afa1580156135b1573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906135d5919061525e565b620f4240906135f2565b8290612ef9565b98975050505050505050565b60008262ffffff168262ffffff16111561361e5760405162461bcd60e51b81526004016102ed906153f9565b50900390565b60008061363086613fd5565b905060128160ff161161365b57612ed68460ff8516600a0a61365488856012614082565b9190613c46565b611bf9816012612ecf888860ff8916600a0a613c46565b600061115b8360ff601285900316600a0a614750565b8061369257613288565b6001600160a01b03808416600090815261013760209081526040808320938616835292905290812054906136c68284613b54565b6001600160a01b0380871660009081526101376020908152604080832089851680855292529091208390556101305492935061010090920416141561370c575050613288565b8115801590613719575080155b15613829576001600160a01b038516600090815261013a60205260408120805490916000198201905b8281101561382057876001600160a01b031684828154811061376057fe5b6000918252602090912001546001600160a01b03161415613818578181146137e75783828154811061378e57fe5b9060005260206000200160009054906101000a90046001600160a01b03168482815481106137b857fe5b9060005260206000200160006101000a8154816001600160a01b0302191690836001600160a01b031602179055505b838054806137f157fe5b600082815260209020810160001990810180546001600160a01b0319169055019055613820565b600101613742565b505050506125dc565b8115801561383657508015155b156125dc576001600160a01b03858116600090815261013a6020908152604080832080546001810182558185529383902090930180546001600160a01b031916898616179055610138548151630262771f60e01b8152915193941692630262771f92600480840193919291829003018186803b1580156138b557600080fd5b505afa1580156138c9573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906138ed9190615292565b60ff16818054905011156139135760405162461bcd60e51b81526004016102ed90615450565b505050505050565b60fd80546001600160a01b0383166001600160a01b0319909116811790915560408051918252517fa4388ecc389b1390354ae0c65a856c0d7dd4fb648419f5d3ac0b99e38f46fd119181900360200190a150565b61397a8383836140cf565b613985828483613ef8565b826001600160a01b0316826001600160a01b03167fd1c19fbcd4551a5edfb66d43d2e337c04837afda3482b42bdf569a8fccdae5fb83604051613003919061533e565b60006139d33061312f565b15905090565b600054610100900460ff16806139f257506139f26139c8565b80613a00575060005460ff16155b613a3b5760405162461bcd60e51b815260040180806020018281038252602e8152602001806157ca602e913960400191505060405180910390fd5b600054610100900460ff16158015613a66576000805460ff1961ff0019909116610100171660011790555b613a6e6147a9565b8015611fa2576000805461ff001916905550565b600054610100900460ff1680613a9b5750613a9b6139c8565b80613aa9575060005460ff16155b613ae45760405162461bcd60e51b815260040180806020018281038252602e8152602001806157ca602e913960400191505060405180910390fd5b600054610100900460ff16158015613b0f576000805460ff1961ff0019909116610100171660011790555b613b1761484e565b613a6e61493d565b6000806000613b2d84612c1c565b925090506000613b3c856127f0565b9050613b4b82612d4b8361328d565b93505050915091565b6000828201818312801590613b695750838112155b80613b7e5750600083128015613b7e57508381125b61115b5760405162461bcd60e51b81526004018080602001828103825260218152602001806157a96021913960400191505060405180910390fd5b600080613bc68484610f00565b9050600080613bd485612d8b565b91509150611bf985613be585612795565b8484613624565b60008282018381101561115b576040805162461bcd60e51b815260206004820152601b60248201527f536166654d6174683a206164646974696f6e206f766572666c6f770000000000604482015290519081900360640190fd5b6000808060001985870986860292508281109083900303905080613c7c5760008411613c7157600080fd5b50829004905061115b565b808411613c8857600080fd5b6000848688096000868103871696879004966002600389028118808a02820302808a02820302808a02820302808a02820302808a02820302808a02909103029181900381900460010186841190950394909402919094039290920491909117919091029150509392505050565b6000808211613d4b576040805162461bcd60e51b815260206004820152601a60248201527f536166654d6174683a206469766973696f6e206279207a65726f000000000000604482015290519081900360640190fd5b818381613d5457fe5b049392505050565b6040516370a0823160e01b81526000906001600160a01b038516906370a0823190613d8b9030906004016152b3565b60206040518083038186803b158015613da357600080fd5b505afa158015613db7573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190613ddb91906151a2565b9050613de9848430856149da565b81613e7082866001600160a01b03166370a08231306040518263ffffffff1660e01b8152600401613e1a91906152b3565b60206040518083038186803b158015613e3257600080fd5b505afa158015613e46573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190613e6a91906151a2565b90613ea1565b146131ed5760405162461bcd60e51b81526004016102ed906153bb565b6000613e988261328d565b60000392915050565b60008282111561361e576040805162461bcd60e51b815260206004820152601e60248201527f536166654d6174683a207375627472616374696f6e206f766572666c6f770000604482015290519081900360640190fd5b604080516001600160a01b038416602482015260448082018490528251808303909101815260649091019091526020810180516001600160e01b031663a9059cbb60e01b179052613288908490614a30565b600081831215612d84578161115b565b6000818303818312801590613f6f5750838113155b80613f845750600083128015613f8457508381135b61115b5760405162461bcd60e51b81526004018080602001828103825260248152602001806158a96024913960400191505060405180910390fd5b600061115b8360ff601285900316600a0a614ae1565b6000816001600160a01b031663313ce5676040518163ffffffff1660e01b815260040160206040518083038186803b15801561401057600080fd5b505afa158015614024573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610d8f9190615292565b6000614055848484613c46565b90506000828061406157fe5b848609111561115b57600019811061407857600080fd5b6001019392505050565b60008160ff168360ff16141561409957508261115b565b8160ff168360ff16116140bd576140b88460ff85850316600a0a614750565b612761565b6127618460ff84860316600a0a613cf5565b610135546040516375cdc89760e11b81526001600160a01b039091169063eb9b912e906141009086906004016152b3565b600060405180830381600087803b15801561411a57600080fd5b505af115801561412e573d6000803e3d6000fd5b50505050600061413e8484610c29565b9050818110156141605760405162461bcd60e51b81526004016102ed90615624565b600061417361416e8461328d565b612769565b610130549091506001600160a01b0385811661010090920416141561423a576101325460405163fd6ceee560e01b81526000916001600160a01b03169063fd6ceee5906141c49089906004016152b3565b602060405180830381600087803b1580156141de57600080fd5b505af11580156141f2573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061421691906151a2565b610130549091506142369061422f90839060ff166130e6565b8390613b54565b9150505b6125dc858583613688565b604080516000808252602082019092526001600160a01b0384169083906040518082805190602001908083835b602083106142915780518252601f199092019160209182019101614272565b6001836020036101000a03801982511681845116808217855250505050505090500191505060006040518083038185875af1925050503d80600081146142f3576040519150601f19603f3d011682016040523d82523d6000602084013e6142f8565b606091505b5050905080613288576040805162461bcd60e51b815260206004820152600360248201526253544560e81b604482015290519081900360640190fd5b6101325460405163293a507760e01b815260009182916001600160a01b039091169063293a50779061436a9087906004016152b3565b60206040518083038186803b15801561438257600080fd5b505afa158015614396573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906143ba91906151a2565b9050612761818461294c565b6000818312612d84578161115b565b600081614429576040805162461bcd60e51b815260206004820181905260248201527f5369676e6564536166654d6174683a206469766973696f6e206279207a65726f604482015290519081900360640190fd5b8160001914801561443d5750600160ff1b83145b156144795760405162461bcd60e51b81526004018080602001828103825260218152602001806157f86021913960400191505060405180910390fd5b600082848161448457fe5b05949350505050565b610130546001600160a01b038481166101009092041614156145ca5761013154604080516385eacc7760e01b815290516000926001600160a01b0316916385eacc77916004808301926020929190829003018186803b1580156144ef57600080fd5b505afa158015614503573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061452791906151a2565b905080846001600160a01b03166370a08231306040518263ffffffff1660e01b815260040161455691906152b3565b60206040518083038186803b15801561456e57600080fd5b505afa158015614582573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906145a691906151a2565b11156145c45760405162461bcd60e51b81526004016102ed906154f0565b506146ef565b61013854604051631ed4896760e31b81526000916001600160a01b03169063f6a44b38906145fc9087906004016152b3565b60806040518083038186803b15801561461457600080fd5b505afa158015614628573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061464c91906151e7565b60600151905080846001600160a01b03166370a08231306040518263ffffffff1660e01b815260040161467f91906152b3565b60206040518083038186803b15801561469757600080fd5b505afa1580156146ab573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906146cf91906151a2565b11156146ed5760405162461bcd60e51b81526004016102ed90615430565b505b6146fd82846129af8461328d565b816001600160a01b0316836001600160a01b03167f8752a472e571a816aea92eec8dae9baf628e840f4929fbcc2d155e6233ff68a783604051613003919061533e565b600081831015612d84578161115b565b60008261475f57506000610d8f565b8282028284828161476c57fe5b041461115b5760405162461bcd60e51b81526004018080602001828103825260218152602001806158196021913960400191505060405180910390fd5b600054610100900460ff16806147c257506147c26139c8565b806147d0575060005460ff16155b61480b5760405162461bcd60e51b815260040180806020018281038252602e8152602001806157ca602e913960400191505060405180910390fd5b600054610100900460ff16158015614836576000805460ff1961ff0019909116610100171660011790555b600180558015611fa2576000805461ff001916905550565b600054610100900460ff168061486757506148676139c8565b80614875575060005460ff16155b6148b05760405162461bcd60e51b815260040180806020018281038252602e8152602001806157ca602e913960400191505060405180910390fd5b600054610100900460ff161580156148db576000805460ff1961ff0019909116610100171660011790555b6148e3614b8a565b60006148ed6108a3565b606580546001600160a01b0319166001600160a01b0383169081179091556040519192509060009060008051602061583a833981519152908290a3508015611fa2576000805461ff001916905550565b600054610100900460ff168061495657506149566139c8565b80614964575060005460ff16155b61499f5760405162461bcd60e51b815260040180806020018281038252602e8152602001806157ca602e913960400191505060405180910390fd5b600054610100900460ff161580156149ca576000805460ff1961ff0019909116610100171660011790555b6149d2614c1b565b613a6e614cbb565b604080516001600160a01b0380861660248301528416604482015260648082018490528251808303909101815260849091019091526020810180516001600160e01b03166323b872dd60e01b1790526131ed9085905b6000614a85826040518060400160405280602081526020017f5361666545524332303a206c6f772d6c6576656c2063616c6c206661696c6564815250856001600160a01b0316614d669092919063ffffffff16565b80519091501561328857808060200190516020811015614aa457600080fd5b50516132885760405162461bcd60e51b815260040180806020018281038252602a8152602001806158cd602a913960400191505060405180910390fd5b600082614af057506000610d8f565b82600019148015614b045750600160ff1b82145b15614b405760405162461bcd60e51b815260040180806020018281038252602781526020018061585a6027913960400191505060405180910390fd5b82820282848281614b4d57fe5b051461115b5760405162461bcd60e51b815260040180806020018281038252602781526020018061585a6027913960400191505060405180910390fd5b600054610100900460ff1680614ba35750614ba36139c8565b80614bb1575060005460ff16155b614bec5760405162461bcd60e51b815260040180806020018281038252602e8152602001806157ca602e913960400191505060405180910390fd5b600054610100900460ff16158015614c17576000805460ff1961ff0019909116610100171660011790555b613a6e5b600054610100900460ff1680614c345750614c346139c8565b80614c42575060005460ff16155b614c7d5760405162461bcd60e51b815260040180806020018281038252602e8152602001806157ca602e913960400191505060405180910390fd5b600054610100900460ff16158015613a6e576000805460ff1961ff0019909116610100171660011790558015611fa2576000805461ff001916905550565b600054610100900460ff1680614cd45750614cd46139c8565b80614ce2575060005460ff16155b614d1d5760405162461bcd60e51b815260040180806020018281038252602e8152602001806157ca602e913960400191505060405180910390fd5b600054610100900460ff16158015614d48576000805460ff1961ff0019909116610100171660011790555b6099805460ff191690558015611fa2576000805461ff001916905550565b6060612761848460008585614d7a8561312f565b614dcb576040805162461bcd60e51b815260206004820152601d60248201527f416464726573733a2063616c6c20746f206e6f6e2d636f6e7472616374000000604482015290519081900360640190fd5b600080866001600160a01b031685876040518082805190602001908083835b60208310614e095780518252601f199092019160209182019101614dea565b6001836020036101000a03801982511681845116808217855250505050505090500191505060006040518083038185875af1925050503d8060008114614e6b576040519150601f19603f3d011682016040523d82523d6000602084013e614e70565b606091505b5091509150614e80828286614e8b565b979650505050505050565b60608315614e9a57508161115b565b825115614eaa5782518084602001fd5b8160405162461bcd60e51b81526004018080602001828103825283818151815260200191508051906020019080838360005b83811015614ef4578181015183820152602001614edc565b50505050905090810190601f168015614f215780820380516001836020036101000a031916815260200191505b509250505060405180910390fd5b600060208284031215614f40578081fd5b813561115b81615754565b600060208284031215614f5c578081fd5b815161115b81615754565b60008060408385031215614f79578081fd5b8235614f8481615754565b91506020830135614f9481615754565b809150509250929050565b60008060008060808587031215614fb4578182fd5b8435614fbf81615754565b93506020850135614fcf81615754565b92506040850135614fdf81615754565b91506060850135614fef81615754565b939692955090935050565b60008060006060848603121561500e578283fd5b833561501981615754565b9250602084013561502981615754565b929592945050506040919091013590565b6000806000806080858703121561504f578384fd5b843561505a81615754565b9350602085013561506a81615754565b9250604085013591506060850135614fef81615769565b60008060408385031215615093578182fd5b823561509e81615754565b91506020830135614f9481615777565b600080604083850312156150c0578182fd5b82356150cb81615754565b946020939093013593505050565b600060208083850312156150eb578182fd5b825167ffffffffffffffff80821115615102578384fd5b818501915085601f830112615115578384fd5b81518181111561512157fe5b8381029150615131848301615730565b8181528481019084860184860187018a101561514b578788fd5b8795505b83861015615179578051945061516485615754565b8483526001959095019491860191860161514f565b5098975050505050505050565b600060208284031215615197578081fd5b815161115b81615769565b6000602082840312156151b3578081fd5b5051919050565b6000806000606084860312156151ce578081fd5b8351925060208401519150604084015190509250925092565b6000608082840312156151f8578081fd5b6040516080810181811067ffffffffffffffff8211171561521557fe5b604052825161522381615754565b8152602083015161523381615777565b6020820152604083015161524681615777565b60408201526060928301519281019290925250919050565b60006020828403121561526f578081fd5b815161115b81615777565b60006020828403121561528b578081fd5b5035919050565b6000602082840312156152a3578081fd5b815160ff8116811461115b578182fd5b6001600160a01b0391909116815260200190565b6001600160a01b0392909216825263ffffffff16602082015260400190565b6020808252825182820181905260009190848201906040850190845b818110156153275783516001600160a01b031683529284019291840191600101615302565b50909695505050505050565b901515815260200190565b90815260200190565b6000602080835283518082850152825b8181101561537357858101830151858201604001528201615357565b818111156153845783604083870101525b50601f01601f1916929092016040019392505050565b602080825260079082015266565f4348434e4360c81b604082015260600190565b602080825260059082015264565f49424160d81b604082015260600190565b602080825260059082015264565f43534960d81b604082015260600190565b6020808252601e908201527f506572704d6174683a207375627472616374696f6e206f766572666c6f770000604082015260600190565b602080825260069082015265565f4754444360d01b604082015260600190565b602080825260069082015265565f43544e4560d01b604082015260600190565b602080825260069082015265565f4d43414560d01b604082015260600190565b6020808252600690820152651597d3d4d0d560d21b604082015260600190565b602080825260069082015265565f43484e4360d01b604082015260600190565b602080825260069082015265565f44465a4160d01b604082015260600190565b602080825260089082015267565f47545354424360c01b604082015260600190565b602080825260049082015263565f5a4160e01b604082015260600190565b602080825260059082015264565f454e4360d81b604082015260600190565b6020808252601c908201527f506572704d6174683a20696e76657273696f6e206f766572666c6f7700000000604082015260600190565b602080825260069082015265565f4d53414560d01b604082015260600190565b602080825260069082015265565f54464e4360d01b604082015260600190565b6020808252600490820152631597d39360e21b604082015260600190565b602080825260059082015264565f574e4360d81b604082015260600190565b602080825260079082015266565f54494e414360c81b604082015260600190565b602080825260069082015265565f4e45464360d01b604082015260600190565b602080825260069082015265565f434d4e4360d01b604082015260600190565b602080825260059082015264565f534e5760d81b604082015260600190565b602080825260079082015266565f57494e414360c81b604082015260600190565b602080825260069082015265565f41424e4360d01b604082015260600190565b6020808252600690820152651597d254d51160d21b604082015260600190565b62ffffff91909116815260200190565b918252602082015260400190565b9384526020840192909252604083015262ffffff16606082015260800190565b60ff91909116815260200190565b60405181810167ffffffffffffffff8111828210171561574c57fe5b604052919050565b6001600160a01b0381168114611fa257600080fd5b8015158114611fa257600080fd5b62ffffff81168114611fa257600080fdfe5265656e7472616e637947756172643a207265656e7472616e742063616c6c005369676e6564536166654d6174683a206164646974696f6e206f766572666c6f77496e697469616c697a61626c653a20636f6e747261637420697320616c726561647920696e697469616c697a65645369676e6564536166654d6174683a206469766973696f6e206f766572666c6f77536166654d6174683a206d756c7469706c69636174696f6e206f766572666c6f778be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e05369676e6564536166654d6174683a206d756c7469706c69636174696f6e206f766572666c6f7753616665436173743a2076616c756520646f65736e27742066697420696e20616e20696e743235365369676e6564536166654d6174683a207375627472616374696f6e206f766572666c6f775361666545524332303a204552433230206f7065726174696f6e20646964206e6f742073756363656564a26469706673582212207d6d8cf2b8d5d73d9ee4468a2e24875bfe84b9ea7a161b8f0794d3d9fde4c7bc64736f6c63430007060033";

export class Vault__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Vault> {
    return super.deploy(overrides || {}) as Promise<Vault>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): Vault {
    return super.attach(address) as Vault;
  }
  connect(signer: Signer): Vault__factory {
    return super.connect(signer) as Vault__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): VaultInterface {
    return new utils.Interface(_abi) as VaultInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Vault {
    return new Contract(address, _abi, signerOrProvider) as Vault;
  }
}
